// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3Rgrf","text":"text___3s6pN","subChildren":"subChildren___3Njg8"};